

import { createHelpers } from 'vuex-map-fields';

const { getUfilterField, updateUfilterField } = createHelpers({
    getterType: `getUfilterField`,
    mutationType: `updateUfilterField`,
});


const state = {
    regions : [],
    organizations : [],
    active_region : {
        id      : 0,
        name    : ''
    },
    active_organization : {},

    users : {},
    exclude : [],
    active_users : [],
    search : '',
}

// actions
const actions = {

    SET_REG_LIST({commit}, data) {
        commit('set_reg_list', data)
    },

    SET_ORG_LIST({commit}, data) {
        commit('set_org_list', data)
    },

    SET_ACTIVE_REG({commit}, data) {
        commit('set_active_reg', data)
    },

    SET_ACTIVE_ORG({commit}, data) {
        commit('set_active_org', data)
    },

    SET_USERS_LIST({commit}, data) {
        commit('set_users_list', data)
    },

    SET_ACTIVE_USERS_LIST ({commit}, data) {
        commit('set_active_users_list',data)
    },

    SET_SEARCH ({commit}) {
        commit('set_search')
    },

    SET_ACTIVE_EXCLUDE ({commit}, data) {
        commit('set_active_exclude', data)
    },
    CLEAN ({commit}){
        commit('clean');
    },


}

const getters = {

    getUfilterField,

};


// mutations
const mutations = {

    updateUfilterField,

    set_search(state,data) {
        state.search = data;
    },

    set_reg_list(state,data) {
        state.regions = {...state.regions, ...data}
    },
    set_org_list(state,data) {
        state.organizations = {...state.organizations, ...data}
    },

    set_active_reg(state,data) {
        state.active_region = {...state.active_region, ...data}
    },

    set_active_org(state,data) {
        state.active_organization = {...state.active_organization, ...data}
    },

    set_users_list(state,data) {
        state.users = data;
    },

    set_active_users_list(state,data) {
        if(data == undefined) {
            data = [];
        }
        state.active_users = data;
    },

    set_active_exclude(state,data) {
        if(data == undefined) {
            data = [];
        }
        state.exclude = data;
    },

    clean (state) {
        //    state.users = [];
        //    state.exclude = [];
        //    state.active_users = [];
    }

}

export default {
    namespaced: true,
    state,
    actions,
    mutations,
    getters
}
